import React from "react";
import { ArrowRight, Hammer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToForge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="2649" id="ready-for-a-transformation" className="dark bg-secondary text-foreground relative w-full overflow-hidden py-32 lg:py-48">
      {}
      <div className="absolute inset-0 z-0">
        {}
        <div className="absolute inset-0 bg-secondary/70 z-10" />
        
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577498/img/modern_glass_office.png)] bg-cover bg-center bg-no-repeat bg-fixed opacity-60 blur-[2px] scale-105" aria-hidden="true" />
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mx-auto max-w-4xl space-y-10">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-white drop-shadow-2xl">
            Your Property, <br className="hidden md:block" />
            <span className="text-primary bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-primary animate-pulse">
              Our Priority.
            </span>
          </h2>
          
          {}
          <p className="text-lg md:text-xl text-primary-100/80 max-w-2xl mx-auto font-medium">
            Premium facility maintenance for residential and commercial excellence. Experience the Elyon Maintenance standard today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-4">
            <Button asChild size="lg" className="h-16 px-10 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/90 border-0 shadow-[0_0_50px_-10px] shadow-primary/50 hover:shadow-[0_0_80px_-15px] hover:shadow-primary/60 transition-all duration-500 hover:scale-105 rounded-full">
              <Link to="https://elyonmaintenance.com/#get-your-maintenance-quote">
                <Hammer className="mr-2 size-6" />
                Get Your Quote
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}